/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {RemindTasksRequest} from '@cash-web/protos/squareup/stafftasks/endpoints/remind-tasks.pb'
import {RemindTasksResponse} from '@cash-web/protos/squareup/stafftasks/endpoints/remind-tasks.pb'


export const remindTasks = (request: RemindTasksRequest, options?: CashRequestOptions) => post<RemindTasksRequest, RemindTasksResponse>("/proxy/services/squareup.stafftasks.service.StaffTasksService/RemindTasks", request, {...options, rejectOnError: true })